<template>
  <div
    class="d-flex align-items-center justify-content-center"
    :class="full ? 'h-100' : 'p-5 m-sm-5'"
  >
    <b-spinner variant="primary" />
  </div>
</template>

<script>
export default {
  name: 'LoadingPage',
  props: {
    full: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
